import React from "react";
import { Switch, Route } from "react-router-dom";
import TalkTeach from "./talk-teach/TalkTeach";
import Share from "./share/Share";
import Talk from "./talk/Talk";
import Interview from "./Interview";

export default function Avatar() {
  return (
    <div>
      <Switch>
        <Route exact path="/avatar" component={Talk} />
        <Route path="/avatar/talk" component={Talk} />
        <Route path="/avatar/share" component={Share} />
        <Route path="/avatar/teach" component={TalkTeach} />
        <Route path="/avatar/interview" component={Interview}/>
      </Switch>
    </div>
  );
}
